import { render, staticRenderFns } from "./MortgageRates.vue?vue&type=template&id=332afdc2&scoped=true"
import script from "./MortgageRates.vue?vue&type=script&lang=js"
export * from "./MortgageRates.vue?vue&type=script&lang=js"
import style0 from "./MortgageRates.vue?vue&type=style&index=0&id=332afdc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332afdc2",
  null
  
)

export default component.exports